import { useEffect, useState } from "react";

// Vite's glob import - eagerly load all images at build time
const imageModules = import.meta.glob('../assets/images/**/*.{jpg,jpeg,png,gif,webp,svg}', {
  eager: true,
  import: 'default'
});

// Create a map with normalized keys (just the relative path from images folder)
const imageMap = Object.keys(imageModules).reduce((acc, key) => {
  // Extract just the path after 'images/'
  // e.g., '../assets/images/banja/banja_0.png' -> 'banja/banja_0.png'
  const match = key.match(/images\/(.+)$/);
  if (match) {
    acc[match[1]] = imageModules[key];
  }
  return acc;
}, {});

const useImage = (filePath) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [image, setImage] = useState(null);

  useEffect(() => {
    const loadImage = () => {
      try {
        // Look up the image in our normalized map
        const imageUrl = imageMap[filePath];

        if (imageUrl) {
          setImage(imageUrl);
          setError(null);
        } else {
          console.error(`Image not found: ${filePath}`);
          console.log('Available images:', Object.keys(imageMap));
          throw new Error(`Image not found: ${filePath}`);
        }
      } catch (err) {
        console.error("Error loading image:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadImage();
  }, [filePath]);

  return {
    loading,
    error,
    image,
  };
};

export default useImage;
